import React, { useLayoutEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { Tooltip } from "antd";

interface TooltipQRProps {
  className?: string;
  title: string;
  style?: object;
  word: string;
  children: React.ReactChildren;
}

interface ContentProps {
  title: string;
  url: string;
}

function Content({ title, url }: ContentProps) {
  const canvas = useRef<HTMLCanvasElement>(null);

  useLayoutEffect(() => {
    if (canvas.current) {
      QRCode.toCanvas(
        canvas.current,
        url,
        { width: 200 },
        function (error: any) {
          if (error) console.error(error);
        }
      );
    }
  });
  return (
    <div className="p-sm">
      <canvas ref={canvas} width="200" height="200" id="canvas_qr" />
      <p className="txt-center txt-white font-size-12">{title}</p>
    </div>
  );
}

export default function TooltipQR(tooltipQRProps: TooltipQRProps) {
  const { className, style = {}, children, word, title } = tooltipQRProps;

  let props: any = {
    ...tooltipQRProps,
    style: {
      ...style,
    },
  };
  if (className) props.className = className;

  const [url, setUrl] = useState("");

  function onMouseOverHandler(url: string) {
    setUrl(url);
  }

  return (
    <Tooltip {...props} title={<Content title={title} url={url} />}>
      <div onMouseOver={onMouseOverHandler.bind(null, word)}>{children}</div>
    </Tooltip>
  );
}
